import { render, staticRenderFns } from "./afterSalesDetail.vue?vue&type=template&id=7fda60c2&scoped=true&"
import script from "./afterSalesDetail.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetail.vue?vue&type=style&index=0&id=7fda60c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fda60c2",
  null
  
)

export default component.exports